import truncate from 'truncate-html';

export let handleTruncate = ($element, limit = 250) => {
	let html = $element.html();
	let text = $element.text();
	let originalHtml = html;
	let readMoreLabel = 'Read More';
	let readLessLabel = 'Read Less';

	console.log("text length", text.length, limit);
	if(text.length > limit) {
		let readMore = `<a class="read-more read-more--more"  href="javascript:void(0)">${readMoreLabel}</a>`;
		let readLess = `<a class="read-more read-more--less"  href="javascript:void(0)">${readLessLabel}</a>`;

		const ellipsis =  ` … `; 

		// trim the string
		let trimmedHtml = truncate(html, limit, {
			decodeEntities: false, 
			ellipsis: ellipsis,
			keepWhitespaces: false			
		});

		if (trimmedHtml.includes(ellipsis)) {

			trimmedHtml = `${trimmedHtml} ${readMore}`;
		}

		$element.html(trimmedHtml);

		$element.on('click', `.read-more`, (event) => {
			if($(event.currentTarget).hasClass('read-more--more')) {
				$element.html(`${originalHtml} ${readLess}`);
			}
			else {
				$element.html(trimmedHtml);
			}
		});
	}
}
